<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="isBackDateDataEntry != 'ACTIVE'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="serialNo"
                  label="PO No"
                  v-model="stockIssue.serialNo"
                  type="text"
                  :rules="rules.serialNoRules(255, 'PO No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="warehouseList"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  v-model="stockIssue.warehouseId"
                  @change="clearIssueNo(), changeWarehouse()"
                  :rules="rules.warehouseRules"
                  :readonly="checkUserWarehouse() ? true : false"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Issue No"
                  v-model="stockIssue.wholeSaleIssueNo"
                  @click="checkWarehouseId()"
                  color="warning"
                  clearable
                  @click:clear="clearIssueNo()"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="reason"
                  label="Reason"
                  v-model="stockIssue.reason"
                  type="text"
                  :rules="rules.reasonRules"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addStockIssueItem()"
                    :disabled="stockIssue.wholeSaleIssueNo ? true : false"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs10 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="
                        (stockIssue.wholeSaleIssueNo ? true : false) ||
                          !stockIssue.warehouseId
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs4>Product</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs3>QC No</v-flex>
                  <v-flex xs2>Batch No</v-flex>
                  <v-flex xs3 class="text-xs-center">MFG Date</v-flex>
                  <v-flex xs3 class="text-xs-center">EXP Date</v-flex>
                  <v-flex xs3>Bin</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  v-for="(stockIssueItem, index) in stockIssue.stockIssueItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      placeholder="Select the code"
                      v-model="stockIssueItem.productCode"
                      @click="showProducts(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                      :disabled="stockIssue.wholeSaleIssueNo ? true : false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="stockIssueItem.productName"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockIssueItem.factorUnitName"
                      :hide-no-data="true"
                      :items="stockIssueItem.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      label="Select"
                      @change="(option) => changeFactorUnit(option, index)"
                      :rules="rules.unitRules"
                      :readonly="isWholeSaleIssueNo"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="stockIssueItem.qty"
                      min="0"
                      :rules="rules.qtyRules"
                      :readonly="isWholeSaleIssueNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="stockIssueItem.qcNo"
                      :items="stockIssueItem.stockQcNoDTOList"
                      item-text="qcNo"
                      item-value="qcNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :readonly="isWholeSaleIssueNo"
                      :hide-no-data="true"
                      :disabled="stockIssueItem.binId ? false : true"
                      @change="getQcBatchNoList(stockIssueItem)"
                    ></v-select>
                    <span
                      style="color: red"
                      v-if="
                        !stockIssueItem.binId &&
                          stockIssue.warehouseId &&
                          stockIssueItem.productId
                      "
                      >Please select bin first.</span
                    >
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      v-model="stockIssueItem.batchNo"
                      :items="stockIssueItem.batchNoList"
                      item-text="batchNo"
                      item-value="batchNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :readonly="isWholeSaleIssueNo"
                      :hide-no-data="true"
                      :disabled="stockIssueItem.binId ? false : true"
                      @change="getBatchDate(stockIssueItem)"
                    ></v-select>
                    <span
                      style="color: red"
                      v-if="
                        !stockIssueItem.binId &&
                          stockIssue.warehouseId &&
                          stockIssueItem.productId
                      "
                      >Please select bin first.</span
                    >
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="isWholeSaleIssueNo"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="MFG Date"
                        type="text"
                        prepend-icon="event"
                        v-model="stockIssueItem.mfgDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="stockIssueItem.mfgDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="isWholeSaleIssueNo"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="EXP Date"
                        type="text"
                        prepend-icon="event"
                        v-model="stockIssueItem.expDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="stockIssueItem.expDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="stockIssueItem.binId"
                      :items="binList"
                      color="blue-grey lighten-2"
                      label="Choose Bin..."
                      item-text="name"
                      menu-props="auto"
                      item-value="id"
                      :rules="rules.binRules"
                      @change="getProductQcBatchDateList(stockIssueItem)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockIssueItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      class="mx-0"
                      icon
                      @click="removeStockIssueItem(index)"
                      :disabled="index == 0 && !stockIssue.wholeSaleIssueNo"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="stockIssue.id ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    @click="onSave"
                    :disabled="!valid || saveLoading"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setProduct(props.item.code, selectedIndex),
                        (showProductListDialog = !showProductListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="600px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3 v-html="errorMessage"></h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--issue no list dialog-->
    <WholeSaleEMRDialog
      :showDialog="showWholeSaleListDialog"
      :params="{
        fromDate: currentDate,
        toDate: currentDate,
        warehouseId: stockIssue.warehouseId,
        status: 'FINISHED',
        type: 'WHOLE_SALE',
      }"
      @close="closeIssueNoDialog"
    ></WholeSaleEMRDialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { productService } from "../../services/product-service";
import { stockIssueService } from "../../services/stockissue-service";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { StockIssueItem } from "../../models/model";
import { StockIssue } from "../../models/model";
import { StockIssueFormRules } from "../../helpers/validation-rules";
import { stockService } from "../../services/stock-service";
import WholeSaleEMRDialog from "./WholeSaleEMRDialog.vue";

export default {
  name: "StockIssueDetail",
  components: { VSwitch, WholeSaleEMRDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    isBackDateDataEntry: JSON.parse(
      localStorage.getItem("BACKDATE_DATA_ENTRY")
    ),
    valid: true,
    saveLoading: false,
    messageDialogBox: false,
    showProductListDialog: false,
    showWholeSaleListDialog: false,
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Stock Issue",
        disabled: false,
        to: "stock-issues",
      },
      {
        text: "Stock Issue Detail",
        disabled: true,
      },
    ],
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    stockIssue: new StockIssue(),
    stockIssueItem: new StockIssueItem(),
    rules: new StockIssueFormRules(),
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    createdDate: "",
    updatedDate: "",
    issueDate: "",
    responseError: "",
    errorMessage: "",
    totalRows: 0,
    selectedIndex: 0,
    scanBarcode: "",
    isWholeSaleIssueNo: false,
    rowsPerPageItems: [10, 50, 100],
    binList: [],
    warehouseList: [],
    productList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },
  created() {
    this.stockIssue.warehouseId = this.checkUserWarehouse();
    this.addStockIssueItem();
    this.getWarehouseList().then(() => {
      this.getBinList();
    });

    const id = this.$route.params.id;
    if (id == "new") {
      // new stockin
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substring(0, 10),
        "YYYY-MM-DD"
      );
      this.stockIssue.isBackDateDataEntry = this.isBackDateDataEntry;
    }
  },
  methods: {
    checkUserWarehouse() {
      if (
        this.user.role.roleName == "WAREHOUSE_MANAGER" ||
        this.user.role.roleName == "WAREHOUSE_STAFF" ||
        this.user.role.roleName == "BRANCH_ADMIN"
      ) {
        return this.user.warehouseId;
      } else if (
        this.user.role.roleName == "PRODUCTION_MANAGER" ||
        this.user.role.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    getBinList() {
      if (this.user.role.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      } else {
        let warehouse = commonService.search(
          "id",
          this.stockIssue.warehouseId,
          this.warehouseList
        );
        if (warehouse) {
          this.binList = warehouse.binList;
        }
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    getWarehouseList() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    addStockIssueItem() {
      // deep copy
      stockIssueItem = new StockIssueItem();
      let stockIssueItem = JSON.parse(JSON.stringify(this.stockIssueItem));
      this.stockIssue.stockIssueItems.push(stockIssueItem);
    },
    removeStockIssueItem(index) {
      this.$delete(this.stockIssue.stockIssueItems, index);
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          //convert to millisecond
          this.stockIssue.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );

          this.stockIssue.stockIssueItems.forEach((stockIssueItem) => {
            if (stockIssueItem.mfgDate) {
              stockIssueItem.mfgDateInMilliSeconds = commonService.convertToMilliseconds(
                stockIssueItem.mfgDate
              );
            }
            if (stockIssueItem.expDate) {
              stockIssueItem.expDateInMilliSeconds = commonService.convertToMilliseconds(
                stockIssueItem.expDate
              );
            }
          });

          stockIssueService
            .saveStockIssue(this.stockIssue)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      this.stockIssue = new StockIssue();
      this.addStockIssueItem();
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showProducts() {
      if (this.stockIssue.warehouseId) {
        // Clean query params
        this.queryParams.code = "";
        this.queryParams.name = "";
        this.queryParams.brandName = "";
        this.queryParams.categoryName = "";
        this.queryParams.productGroupName = "";
        this.productList = [];

        this.getProductList().then(
          (this.showProductListDialog = !this.showProductListDialog)
        );
      } else {
        this.errorMessage = "Please select warehouse first.";
        this.messageDialogBox = true;
      }
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockIssue.stockIssueItems[index].productId = product.id;
      this.stockIssue.stockIssueItems[index].productCode = product.code;
      this.stockIssue.stockIssueItems[index].productName = product.name;
      if (this.binList.length > 0) {
        this.stockIssue.stockIssueItems[index].binId = this.binList[0].id;
        this.getProductQcBatchDateList(this.stockIssue.stockIssueItems[index]);
      }

      // set default unit
      var j = "";
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.stockIssue.stockIssueItems[index].productUnitId =
        product.productUnits[j].id;
      this.stockIssue.stockIssueItems[index].factorUnitName =
        product.productUnits[j].factorUnitName;
      this.stockIssue.stockIssueItems[index].productUnits =
        product.productUnits;
      this.stockIssue.stockIssueItems[index].qty = 0;
      this.clearQCno(this.stockIssue.stockIssueItems[index]);
    },
    getProductQcBatchDateList(stockIssueItem) {
      stockIssueItem.qcNo = "";
      stockIssueItem.batchNo = "";
      stockIssueItem.mfgDate = "";
      stockIssueItem.expDate = "";
      let params = {
        warehouseId: this.stockIssue.warehouseId,
        binId: stockIssueItem.binId,
        productId: stockIssueItem.productId,
        balanceType: "WITH_BALANCE",
      };
      return stockService
        .getStockQcBatchDateList(params)
        .then((res) => {
          stockIssueItem.stockQcNoDTOList = res.data;
          this.getQcBatchNoList(stockIssueItem);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQcBatchNoList(stockIssueItem) {
      stockIssueItem.batchNo = "";
      stockIssueItem.mfgDate = "";
      stockIssueItem.expDate = "";
      let qc = stockIssueItem.stockQcNoDTOList.find(
        (v) => v.qcNo == stockIssueItem.qcNo
      );
      if (qc) {
        stockIssueItem.batchNoList = qc.batchNoList;
        this.getBatchDate(stockIssueItem);
      }
    },
    getBatchDate(stockIssueItem) {
      stockIssueItem.mfgDate = "";
      stockIssueItem.expDate = "";
      let batchNo = stockIssueItem.batchNoList.find(
        (v) => v.batchNo == stockIssueItem.batchNo
      );
      if (batchNo) {
        let batchDate = batchNo.qcBatchDateDTOList.find(
          (v) => v.batchNo == stockIssueItem.batchNo
        );
        if (batchDate) {
          stockIssueItem.mfgDate = batchDate.mfgDate;
          stockIssueItem.expDate = batchDate.expDate;
        }
      }
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            this.setProductByBarcode(productUnit);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },
    setProductByBarcode(productUnit) {
      if (this.stockIssue.stockIssueItems[0].productCode == "")
        this.addValuesToFirstStockIssueItem(productUnit);
      else if (this.isItemExistAddQty(productUnit));
      else this.addNewItemToStockIssueItemList(productUnit);
    },
    isItemExistAddQty(productUnit) {
      for (let item of this.stockIssue.stockIssueItems) {
        if (item.productUnitId === productUnit.id) {
          item.qty = Math.abs(item.qty) + 1;
          return true;
        }
      }
    },
    addValuesToFirstStockIssueItem(productUnit) {
      this.stockIssue.stockIssueItems[0].productId = productUnit.product.id;
      this.stockIssue.stockIssueItems[0].productCode = productUnit.product.code;
      this.stockIssue.stockIssueItems[0].productName = productUnit.product.name;
      this.stockIssue.stockIssueItems[0].productUnitId = productUnit.id;
      this.stockIssue.stockIssueItems[0].productUnits.push(productUnit);
      this.stockIssue.stockIssueItems[0].factorUnitName =
        productUnit.factorUnitName;
      this.stockIssue.stockIssueItems[0].qty = 1;
      this.stockIssue.stockIssueItems[0].binId = this.binList[0].id;
    },
    addNewItemToStockIssueItemList(productUnit) {
      let stockIssueItem = JSON.parse(JSON.stringify(this.stockIssueItem));

      stockIssueItem.productId = productUnit.product.id;
      stockIssueItem.productCode = productUnit.product.code;
      stockIssueItem.productName = productUnit.product.name;
      stockIssueItem.productUnitId = productUnit.id;
      stockIssueItem.productUnits[0] = productUnit;
      stockIssueItem.factorUnitName = productUnit.factorUnitName;
      stockIssueItem.qty = 1;
      stockIssueItem.binId = this.binList[0].id;

      this.stockIssue.stockIssueItems.push(stockIssueItem);
    },
    changeFactorUnit(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.stockIssue.stockIssueItems[index].productUnits
      );
      if (this.checkItemDuplicate(productUnit, index)) {
        let item = productUnit.product.name + " (" + factorUnitName + ")";
        this.errorMessage = "Stock Issue Item: " + item + " is duplicated";
        this.messageDialogBox = true;
      }
      this.stockIssue.stockIssueItems[index].productUnitId = productUnit.id;
    },
    checkItemDuplicate(productUnit, index) {
      for (let item in this.stockIssue.stockIssueItems) {
        if (item != index) {
          let puId = this.stockIssue.stockIssueItems[item].productUnitId;
          if (puId === productUnit.id) {
            return true;
          }
        }
      }
    },
    clearQCno(stockIssueItem) {
      stockIssueItem.qcNo = "";
      stockIssueItem.batchNo = "";
      stockIssueItem.mfgDate = "";
      stockIssueItem.mfgDateInMilliSeconds = "";
      stockIssueItem.expDate = "";
      stockIssueItem.expDateInMilliSeconds = "";
    },
    checkWarehouseId() {
      if (this.stockIssue.warehouseId) {
        this.showWholeSaleListDialog = !this.showWholeSaleListDialog;
      } else {
        this.messageDialogBox = true;
        this.errorMessage = "Please choose warehouse first!";
      }
    },
    closeIssueNoDialog(stockIssue) {
      if (!(JSON.stringify(stockIssue) === "{}")) {
        this.stockIssue.wholeSaleIssueNo = stockIssue.issueNo;
        this.isWholeSaleIssueNo = stockIssue.isWholeSaleIssueNo;
        if (this.binList.length > 0) {
          this.stockIssue.stockIssueItems = [];
          stockIssue.stockIssueDetailList.forEach((item) => {
            item.binId = this.binList[0].id;
            this.getProductQcBatchDateList(item);
            this.stockIssue.stockIssueItems.push(item);
          });
        } else {
          this.stockIssue.stockIssueItems = stockIssue.stockIssueDetailList;
        }
      }
      this.showWholeSaleListDialog = !this.showWholeSaleListDialog;
    },
    clearIssueNo() {
      if (this.stockIssue.wholeSaleIssueNo) {
        this.stockIssue.wholeSaleIssueNo = "";
        this.isWholeSaleIssueNo = false;
        this.stockIssue.stockIssueItems = [];
        this.addStockIssueItem();
      }
    },
    changeWarehouse() {
      this.stockIssue.stockIssueItems = [];
      this.addStockIssueItem();
      this.getBinList();
    },
  },
};
</script>
